import React, { useEffect } from 'react'
import { Button, Col, DatePicker, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { SearchOutlined } from '@ant-design/icons'
import SelectExecutionStatus from '../../../components/selects/SelectExecutionStatus'
import SelectQuestionType from '../../../components/selects/SelectQuestionType'
import { dateFormat } from '../../../utils'
import { SelectTerritorialUnits } from '../../../components/selects'
import SelectTerritorialUnitsKurultai from '../../../components/selects/SelectTerritorialUnitsKurultai'

interface IProps {
	formField: any
	form: any
	onReset: () => void
	onSearch: () => void
}

export const FilterKurultaiRegister = (props: IProps) => {
	const { t } = useTranslation()

	return (
		<Form form={props.form} layout='vertical'>
			<Row gutter={16}>
				<Col span={6}>
					<Form.Item
						label={t('kurultai.executionStatus')}
						name={props.formField.executionStatusIds}
					>
						<SelectExecutionStatus multiple={true} />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label={t('titles.territorialUnitRegion')} name={props.formField.regionIds}>
						<SelectTerritorialUnitsKurultai multiple={true} type={['REGION']} />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label={t('kurultai.assemblyDateFrom')} name={props.formField.assemblyDateFrom}>
						<DatePicker format={dateFormat} placeholder={t('Выберите дату')} />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={6}>
					<Form.Item
						label={t('kurultai.questionCategory')}
						name={props.formField.questionCategoryIds}
					>
						<SelectQuestionType multiple={true} />
					</Form.Item>
				</Col>

				<Col span={6}>
					<Form.Item
						label={t('kurultai.responsibleAuthority')}
						name={props.formField.responsibleAuthority}
					>
						<Input placeholder={t('Введите наименование органа')} />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label={t('kurultai.assemblyDateTo')} name={props.formField.assemblyDateTo}>
						<DatePicker format={dateFormat} placeholder={t('Выберите дату')} />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={6}>
					<Form.Item label={t('kurultai.assembly_number')} name={props.formField.assemblyNumber}>
						<Input placeholder={t('Например, 32')} />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label={t('kurultai.delegate_name')} name={props.formField.delegateName}>
						<Input placeholder={t('Введите ФИО')} />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={12} style={{ display: 'flex', alignItems: 'end', gap: '10px' }}>
					<Button type='primary' shape='default' icon={<SearchOutlined />} onClick={props.onSearch}>
						{t('general.search')}
					</Button>
					<Button
						onClick={() => {
							props.form.resetFields()
							props.onReset()
						}}
						style={{ color: 'orange' }}
					>
						{t('general.reset')}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
